import { colors } from "@indeed/ifl-tokens";
import { SystemStyleObject } from "@indeed/ifl-css";

export const heroStyles: SystemStyleObject = {
  pt: [10, null, null, 12],
};

export const fullBleed: SystemStyleObject = {
  margin: "0 -10vw",
  px: "10vw",
};

export const fullWidthStyles: SystemStyleObject = {
  my: 0,
  width: "80vw",
  aspectRatio: "16/9",
};

export const contentItemStyles: SystemStyleObject = {
  width: "100%",
  h2: {
    fontSize: ["32px", null, null, "56px"],
    fontWeight: 300,
    lineHeight: [1.15, null, null, 1.25],
    mt: 0,
  },
  p: { fontSize: ["16px", null, null, "20px"], lineHeight: 1.5 },
  "p strong": {
    fontSize: ["24px", null, null, "28px"],
    fontWeight: 500,
    lineHeight: 1.25,
  },
  "ul li": {
    fontSize: ["16px", null, null, "20px"],
    fontWeight: 400,
    lineHeight: 1.5,
    pb: "10px",
  },
  a: {
    textDecoration: "none",
    color: "primary.800",
    ":visited": { color: "primary.800" },
  },
};

export const articleContentStyles: SystemStyleObject = {
  "p, strong, em": { fontFamily: "Indeed Sans" },
  a: {
    color: "#2557a7",
  },
  figure: {
    mt: "40px !important",
    mb: "40px !important",
    a: {
      width: "100%",
    },
  },
  ".aligncenter": {
    display: "block",
    m: "auto",
  },
  iframe: {
    display: "block",
    m: "auto",
  },
  figcaption: {
    fontSize: "16px",
    textAlign: "left",
    alignSelf: "flex-start",
    m: "10px 0",
  },
};

export const focusVisibleStyles: SystemStyleObject = {
  ":focus-visible": {
    outline: "none",
    boxShadow: `0 0 0 2px ${colors.primary[100]}, 0 0 0 3px ${colors.primary[800]}`,
    borderRadius: "md",
  },
  ":focus": {
    border: "none !important",
  },
};

export const ArticleHeroCreditStyles: SystemStyleObject = {
  fontWeight: 500,
  fontSize: 3,
  lineHeight: "24px",
};
